module.exports = __webpack_public_path__ + "img/Brown.1d937316.jpeg";